import { createSlice } from "@reduxjs/toolkit";
import { Tutorial } from "domain/entities/tutorials.entities";
import {
  getFavoritesTutorials,
  getRandomTutorial,
  getTutorial,
  getTutorials,
  setIsTutorialLoading,
} from "domain/tutorials/tutorials.actions";

export type TutorialsState = {
  isTutorialsLoading: boolean;
  tutorials: Tutorial[];
  isTutorialLoading: boolean;
  tutorial: Tutorial;
  totalCount: number;
  randomTutorial: Tutorial | null;
};

const initialState: TutorialsState = {
  isTutorialsLoading: false,
  tutorials: [],
  isTutorialLoading: false,
  tutorial: null,
  totalCount: 0,
  randomTutorial: null,
};

export const tutorialsSlice = createSlice({
  name: "tutorials",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //GET TUTORIALS
    builder.addCase(getTutorials.fulfilled, (state, action) => {
      state.tutorials = action.payload.tutorials;
      state.totalCount = action.payload.totalCount;
      state.isTutorialsLoading = false;
    });
    builder.addCase(getTutorials.pending, (state, action) => {
      state.isTutorialsLoading = true;
    });
    //SET IS TUTORIAL LOADING
    builder.addCase(setIsTutorialLoading.fulfilled, (state, action) => {
      state.isTutorialLoading = action.payload.isLoading;
    });
    //GET TUTORIAL
    builder.addCase(getTutorial.fulfilled, (state, action) => {
      state.tutorial = action.payload.tutorial;
      state.isTutorialLoading = false;
    });
    builder.addCase(getTutorial.pending, (state, action) => {
      state.isTutorialLoading = true;
    });
    //GET FAVORITES TUTORIALS
    builder.addCase(getFavoritesTutorials.fulfilled, (state, action) => {
      state.tutorials = action.payload.tutorials;
      state.isTutorialsLoading = false;
    });
    builder.addCase(getFavoritesTutorials.pending, (state, action) => {
      state.isTutorialsLoading = true;
    });
    //GET RANDOM TUTORIAL
    builder.addCase(getRandomTutorial.fulfilled, (state, action) => {
      state.randomTutorial = action.payload.tutorial;
      state.isTutorialLoading = false;
    });
    builder.addCase(getRandomTutorial.pending, (state, action) => {
      state.isTutorialLoading = true;
    });
  },
});
